import React, { Component } from 'react'
import Write from '../write/Write'
import ViEditor from '../writingEditor/ViEditor'
export default class Editor extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.data.story !== '' 
            ?
                <span>
                    {this.props.data.Editor!= null && this.props.data.Editor == "vi-Editor"
                    ?   <ViEditor editorId="viEditorDiary" auth={this.props.auth} keypass={this.props.data.decpass} story={this.props.data.story} data={this.props.data} />
                    :   <Write auth={this.props.auth} keypass={this.props.data.decpass} story={this.props.data.story} date={this.props.data.idata} />   
                    }
                    <button className='addbtn' onClick={this.props.new}>Open New</button>
                </span> 
            :
                this.props.data.Editor!= null && this.props.data.Editor == "vi-Editor"
                ?   <ViEditor editorId="viEditorDiary" auth={this.props.auth} keypass={this.props.data.decpass} />
                :   <Write auth={this.props.auth} keypass={this.props.data.decpass} />
        }

      </React.Fragment>
    )
  }
}
